/**
 * SectionMarker — a numbered section marker.
 * Renders a gold hairline rule, a font-display number, and a label.
 * e.g. <SectionMarker num="01" label="Our Mission" />  -> 01 — Our Mission
 * Use sparingly (at most once or twice per page).
 */
export default function SectionMarker({ num, label, className = '' }) {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <span className="font-display text-sm font-bold tracking-tight text-maroon-700">{num}</span>
      <span className="h-px w-10 shrink-0 bg-gold-400" aria-hidden="true" />
      <span className="text-xs font-semibold uppercase tracking-[0.22em] text-ink-soft">{label}</span>
    </div>
  );
}
